import React from 'react';
import { useNavigate } from 'react-router-dom';
import './CancelRegistration.scss';

const CancelRegistration = () => {
  const navigate = useNavigate();

  const handleSignUp = () => {
    navigate('/');
  };

  return (
    <div className="cancel-registration-page page-container">
      <div className="page-title">
        <h1>LeapFrog Lab Registration</h1>
      </div>

      <div className="child-form form-group">
        <h2 className="page-subtitle">Your registration has been canceled</h2>
        <p>
          All data you may have entered has been completely removed from our
          database.
        </p>
        <p>
          We thank you for your time, and respect your privacy - you will not be
          contacted by LeapFrog representatives if no registration data has been
          entered.
        </p>
        <p>
          If you would like to start over, please click{' '}
          <strong className="highlight-signup">Sign Up</strong> button below.
        </p>
        <div className="cancel-registration-actions button-group">
          <button className="button primary" onClick={handleSignUp}>
            Sign Up
          </button>
        </div>
      </div>
    </div>
  );
};

export default CancelRegistration;
